import { useState } from "react";

import SignupModal from "@/components/signup-modal";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import useAuth from "@/hooks/use-auth";

import useSelectedSortOption from "../../hooks/use-selected-sort-option";
import useSortMenuOptions from "../../hooks/use-sort-menu-options";
import { SortEnum } from "../../types";
import { CloseIcon, OptionIcon, SelectedOptionIcon } from "./icons";

type SortMenuProps = React.ComponentProps<typeof Dialog>;

export default function SortMenu(props: SortMenuProps) {
  const [isOpen, setIsOpen] = useState(false);

  const { isUser } = useAuth();

  const [selectedOption, setSelectedOption] = useSelectedSortOption(() =>
    props.onOpenChange?.(false)
  );
  const menuOptions = useSortMenuOptions(true);

  const handleOption = (sortBy: SortEnum) => () => {
    if (!isUser && sortBy === SortEnum.MY_RATING) {
      setIsOpen(true);
    } else {
      setSelectedOption(sortBy);
    }
  };

  return (
    <>
      <Dialog {...props}>
        <DialogContent
          className="gap-0 bg-transparent"
          overlayClassName="bg-gray-cool/64"
        >
          <DialogHeader className="rounded-t-[10px] bg-rich-black py-2.5 shadow-0-4-8 shadow-midnight-velvet/40">
            <DialogTitle className="text-center font-medium text-16">
              Sort
            </DialogTitle>
          </DialogHeader>
          <Button
            aria-label="Close"
            className="absolute top-0 left-0 h-11 w-13"
            onClick={() => props.onOpenChange?.(false)}
          >
            <CloseIcon />
          </Button>
          <ul className="flex flex-col items-stretch bg-space-gray-dark pt-5 pr-4 pb-14 pl-4 [&_li+li]:mt-[15px] [&_li+li]:border-white/8 [&_li+li]:border-t [&_li+li]:pt-[15px]">
            {Object.entries(menuOptions).map(([value, { icon, label }]) => (
              <li key={value}>
                <Button
                  className="flex h-5 w-full items-center justify-start"
                  onClick={handleOption(value as SortEnum)}
                >
                  {icon}
                  {label}
                  {selectedOption === value ? (
                    <SelectedOptionIcon className="ml-auto" />
                  ) : (
                    <OptionIcon className="ml-auto" />
                  )}
                </Button>
              </li>
            ))}
          </ul>
        </DialogContent>
      </Dialog>
      <SignupModal onOpenChange={setIsOpen} open={isOpen} />
    </>
  );
}
